import { render, staticRenderFns } from "./vue-magnifier.vue?vue&type=template&id=403ca5fa&"
import script from "./vue-magnifier.vue?vue&type=script&lang=js&"
export * from "./vue-magnifier.vue?vue&type=script&lang=js&"
import style0 from "./vue-magnifier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vue-magnifier.vue"
export default component.exports